import React from 'react';
import { Box, Typography } from '@material-ui/core';

const EmptyState = ({ message }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    minHeight={80}
    minWidth={1000}
    bgcolor="#fafafa"
    borderRadius={8}
    border="1px dashed #ccc"
    p={4}
    mt={2}
  >
    <Typography variant="h6" color="textSecondary" align="center">
      {message || 'No data available.'}
    </Typography>
  </Box>
);

export default EmptyState;
